/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoYoutubeIcon16Light } from './LogoYoutubeIcon16Light';
import { LogoYoutubeIcon16Regular } from './LogoYoutubeIcon16Regular';
import { LogoYoutubeIcon16Solid } from './LogoYoutubeIcon16Solid';
import { LogoYoutubeIcon20Light } from './LogoYoutubeIcon20Light';
import { LogoYoutubeIcon20Regular } from './LogoYoutubeIcon20Regular';
import { LogoYoutubeIcon20Solid } from './LogoYoutubeIcon20Solid';
import { LogoYoutubeIcon24Regular } from './LogoYoutubeIcon24Regular';
import { LogoYoutubeIcon24Solid } from './LogoYoutubeIcon24Solid';
import { LogoYoutubeIcon32Regular } from './LogoYoutubeIcon32Regular';
import { LogoYoutubeIcon64Regular } from './LogoYoutubeIcon64Regular';
var sizes = {
    16: {
        light: LogoYoutubeIcon16Light,
        regular: LogoYoutubeIcon16Regular,
        solid: LogoYoutubeIcon16Solid,
    },
    20: {
        light: LogoYoutubeIcon20Light,
        regular: LogoYoutubeIcon20Regular,
        solid: LogoYoutubeIcon20Solid,
    },
    24: {
        regular: LogoYoutubeIcon24Regular,
        solid: LogoYoutubeIcon24Solid,
    },
    32: {
        regular: LogoYoutubeIcon32Regular,
    },
    64: {
        regular: LogoYoutubeIcon64Regular,
    },
};
export var LogoYoutubeIcon = forwardRef('LogoYoutubeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
